import {
  roomMixerStreamEntityRaw,
  RoomMixerStreamEntityRaw
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";
import { BaseResponseDTO } from "@youm-front/common/domain";

export class RoomMixerStreamGetResponseDTO extends BaseResponseDTO<RoomMixerStreamGetResponseDTORaw> {
  private static validation = JsonSchemaValidator.compile(
    RoomMixerStreamGetResponseDTO.validationSchema()
  );

  constructor(value: RoomMixerStreamGetResponseDTORaw) {
    super(
      JsonSchemaValidator.assert(
        RoomMixerStreamGetResponseDTO.validation,
        value
      )
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["stream"],
      properties: {
        stream: {
          anyOf: [{ type: "null" }, roomMixerStreamEntityRaw]
        }
      },
      additionalProperties: false
    };
  }
}

export interface RoomMixerStreamGetResponseDTORaw {
  stream: null | RoomMixerStreamEntityRaw;
}
